import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { useEffect } from 'react';

export type RawTextareaEditablePluginProps = {
  isEditable: boolean;
};

/**
 * Keeps the editor's editable state in step with the `disabled` and `readonly`
 * props.
 *
 * `LexicalComposer`'s `initialConfig.editable` is read once, at mount, so a
 * textarea that starts editable stays editable even after `disabled` is set —
 * while the toolbar, being ordinary render output, disappears correctly. That
 * leaves a field with no toolbar that can still be typed into. The Draft.js
 * implementation took `readOnly` as a live prop and so had no equivalent gap.
 */
export const RawTextareaEditablePlugin = ({
  isEditable,
}: RawTextareaEditablePluginProps) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    editor.setEditable(isEditable);
  }, [editor, isEditable]);

  return null;
};
